import { connect } from "react-redux";

import { EmailDetailsRedux } from "./emailDetails";
import { EmailPivotRedux } from "./emailPivot";
import { SummaryBarRedux } from "./summaryBar";
import { EmailFilterBar } from "./filterBar";
import { Trend } from "./trend";

import "./email.scss";

const mapStateToProps = (state) => ({
    section: state.emails.section
});

const mapDispatchToProps = {};

export const EmailAnalyticsPage = connect(mapStateToProps, mapDispatchToProps)(({ section, viewInspector }) => (
    <div className="email-analytics">
        <EmailFilterBar />
        <SummaryBarRedux />
        <div className="chart requests-trend-chart">
            <Trend />
        </div>
        {section === "details"
            ? <EmailDetailsRedux />
            : <div className="requests-body"><EmailPivotRedux /></div>}
    </div>
));
